import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OverrideCandidateSuspensionComponent } from './override-candidate-suspension.component';
import { AiAssistantModule } from '../ai-assistant/ai-assistant.module';

@NgModule({
  declarations: [OverrideCandidateSuspensionComponent],
  imports: [
    CommonModule,
    FormsModule,
    AiAssistantModule
  ],
  exports: [OverrideCandidateSuspensionComponent],
  entryComponents: [OverrideCandidateSuspensionComponent]
})
export class OverrideCandidateSuspensionModule { }
